import PropTypes from "prop-types"
import React, { useState } from "react"

import { connect } from "react-redux"

import { Link } from "react-router-dom"

// Import menuDropdown
import ProfileMenu from "./ProfileMenu"

import styles from "../../constants/styles"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  toggleLeftmenu,
  changeSidebarType,
  changeLeftSidebarIsIcon,
} from "../../store/actions"

const Header = props => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 992) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
      props.changeLeftSidebarIsIconAction()
    }
  }

  return (
    <React.Fragment>
      <header
        id="page-topbar"
        className={props.newVersion ? "new-version" : ""}
      >
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              {props.style && (
                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src={styles[props.style].images.icon}
                      alt=""
                      height="35"
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={styles[props.style].images.logo}
                      alt=""
                      height="50"
                    />
                  </span>
                </Link>
              )}
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle()
              }}
              data-target="#topnav-menu-content"
            >
              <i className="mdi mdi-menu"></i>
            </button>
            <button
              className="btn header-item waves-effect pl-0"
              tag="button"
              style={{ cursor: "default", fontSize: "1.2rem" }}
            >
              <span>{props.metaData && props.metaData.Name}</span>
            </button>
          </div>

          <div className="d-flex">
            <div className="dropdown d-none d-lg-inline-block">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon waves-effect"
                data-toggle="fullscreen"
              >
                <i className="mdi mdi-fullscreen"></i>
              </button>
            </div>

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStateToProps = state => {
  const { layoutType, leftMenu, leftSideBarType } = state.Layout
  const { style, metaData } = state.CMS
  return { layoutType, leftMenu, leftSideBarType, style, metaData }
}

export default connect(mapStateToProps, {
  toggleLeftmenu,
  changeSidebarType,
  changeLeftSidebarIsIconAction: changeLeftSidebarIsIcon,
})(withTranslation()(Header))
